import { useCopyToClipboard } from "@uidotdev/usehooks";
import { t } from "ttag";

import { usePortalUserStore } from "@/app/stores";
import { EXTERNAL_LINK } from "@/config/external-links";
import { REFERRAL_CREDIT_AMOUNT } from "@/shared/domains/referral";
import { useMediaQuery } from "@/shared/hooks";
import {
  IS_WEB_VIEW,
  sendMessageToReactNativeWebView,
  WEB_VIEW_ACTIONS,
} from "@/shared/lib";
import { useToastStore } from "@/shared/ui";

export const useReferralCode = () => {
  const [, copyToClipboard] = useCopyToClipboard();
  const isSmallDevice = useMediaQuery("TABLET");
  const pushToast = useToastStore((state) => state.pushToast);

  const referralCode = usePortalUserStore(
    (state) => state.portalUser?.referralCode,
  );

  const shareCode = () => {
    if (!referralCode) {
      return;
    }

    if (IS_WEB_VIEW) {
      return sendMessageToReactNativeWebView({
        type: WEB_VIEW_ACTIONS.SHARE,
        payload: {
          title: t`Join me on LevelsRx`,
          text: t`Use my code ${referralCode} to get $${REFERRAL_CREDIT_AMOUNT} and start your wellness journey.`,
        },
      });
    }

    if (navigator.share && isSmallDevice) {
      void navigator
        .share({
          title: t`Join me on LevelsRx`,
          text: t`Use my code ${referralCode} to get $${REFERRAL_CREDIT_AMOUNT} and start your wellness journey.`,
          url: EXTERNAL_LINK.HOME,
        })
        .catch((error: Error) => {
          if (error.name !== "AbortError") {
            void pushToast({
              type: "error",
              message: t`Sharing failed, please try again`,
            });
          }
        });
    } else {
      void copyToClipboard(referralCode);
      void pushToast({
        type: "success",
        message: t`Code copied to clipboard.`,
      });
    }
  };

  return { referralCode, actions: { shareCode } };
};
